function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("rect", {
  x: 5,
  y: 3,
  width: 34,
  height: 34,
  rx: 6,
  fill: "white"
}), React.createElement("path", {
  d: "M28.2637 18.0529C28.5449 18.3341 28.5449 18.7888 28.2637 19.0701C27.9824 19.3513 27.5277 19.3513 27.2465 19.0701L22.0001 13.8237L16.7538 19.0701C16.4725 19.3513 16.0179 19.3513 15.7366 19.0701C15.5963 18.9298 15.5258 18.7456 15.5258 18.5615C15.5258 18.3773 15.5963 18.1931 15.7366 18.0529L21.4915 12.2979C21.7728 12.0167 22.2275 12.0167 22.5087 12.2979L28.2637 18.0529Z",
  fill: "#5A186D"
}), React.createElement("path", {
  d: "M22.5087 19.4915L28.2637 25.2465C28.5449 25.5277 28.5449 25.9824 28.2637 26.2637C27.9824 26.5449 27.5277 26.5449 27.2465 26.2637L22.0001 21.0173L16.7538 26.2637C16.4725 26.5449 16.0179 26.5449 15.7366 26.2637C15.5963 26.1234 15.5258 25.9392 15.5258 25.7551C15.5258 25.5709 15.5963 25.3867 15.7366 25.2465L21.4915 19.4915C21.7728 19.2103 22.2275 19.2103 22.5087 19.4915Z",
  fill: "#5A186D"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 44,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), React.createElement("feOffset", {
  dy: 2
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgWithdrawal = function SvgWithdrawal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWithdrawal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/withdrawal.53e19b5b.svg";
export { ForwardRef as ReactComponent };